import { FC } from 'react';
import cn from 'classnames';
import { useNavigate } from 'react-router-dom';
import { Action, Label, TableRow } from '../../atoms';
import { UserDto } from '../../../store/contextAPI/user/dto/response/user.dto';
import { getInitiativeNames } from '../../../utils/Helpers/initiatives-helper';
import { formatDate } from '../../../utils/Helpers/date-helper';
import ServerSortableTable from '../../molecules/ServerSortableTable';
import { SortConfig } from '../../../utils/types/types';
import { Role } from '../../../store/contextAPI/role/dto/response/role.dto';
import { getRoleSeparation } from '../../../utils/Helpers/role-helper';
import styles from './UserManagemenetUsers.module.css';

export const getRoles = (roles: Role[]) => {
  if (!roles?.length) return null;

  return roles.map((role, index) => (
    <p key={role.id ?? index}>
      {getRoleSeparation(role.name)}
      {index < roles.length - 1 && ','}
    </p>
  ));
};

interface UserManagementUsersProps {
  data: UserDto[];
  sortConfig: SortConfig;
  isInactive: boolean;
  handleDeleteUser: (id: string) => void;
  setSortConfig: (value: SortConfig) => void;
}

const UserManagementUsers: FC<UserManagementUsersProps> = ({
  data,
  sortConfig,
  isInactive,
  handleDeleteUser,
  setSortConfig,
}) => {
  const navigate = useNavigate();

  const handleUpdateUser = (id: string) => {
    navigate(`/user-management/users/${id}/edit/details`);
  };

  return (
    <ServerSortableTable
      data={data}
      sortConfig={sortConfig}
      setSortConfig={setSortConfig}
      showEditButtonHeader={!isInactive}
      showDeleteButtonHeader={!isInactive}
      columns={[
        { label: 'Name', key: 'name', sortKey: 'name' },
        { label: 'Email', key: 'email', sortKey: 'email' },
        { label: 'Company Name', key: 'companyName', sortKey: 'companyName' },
        { label: 'Role', key: 'roles' },
        {
          label: 'Verification Status',
          key: 'verificationStatus',
          sortKey: 'verificationStatus',
        },
        { label: 'Creation Date', key: 'createdAt', sortKey: 'dateCreated' },
        { label: 'Profile Name', key: 'profileNames' },
        {
          label: 'Newsletter subscription status',
          key: 'isSubscribedToNewsletter',
          sortKey: 'subscriptionStatus',
        },
      ]}
      renderRow={(row) => (
        <TableRow key={row.id}>
          <Label content={row.name} noBreak></Label>
          <Label content={row.email}></Label>
          <Label content={row.companyName} noBreak></Label>
          <div className={cn(styles.userRoleWrapper)}>
            {getRoles(row.roles)}
          </div>
          <Label content={row.verificationStatus.toString()} bold></Label>
          <Label content={formatDate(row.createdAt)} noBreak></Label>
          <Label
            content={getInitiativeNames(row.profileNames, row.roles)}
            noBreak
          ></Label>
          <Label
            content={
              row.isSubscribedToNewsletter ? 'Subscribed' : 'Not Subscribed'
            }
          ></Label>
          {!isInactive && (
            <Action
              type="edit"
              size="xs"
              onClick={() => handleUpdateUser(row.id)}
            />
          )}
          {!isInactive && (
            <Action
              type="delete"
              itemName={row.name}
              size="xs"
              onClick={() => handleDeleteUser(row.id)}
            />
          )}
        </TableRow>
      )}
    />
  );
};

export default UserManagementUsers;
